/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useLayout } from '../core'
import { getAPIVersion } from '../../helpers/crud-helper/_request'
import { VersionAPI } from '../../helpers'

export const Footer: FC = () => {
  const [APIData, setAPIData] = useState<VersionAPI>()

  const getVersion = async () => {
    const data = await getAPIVersion()
    setAPIData(data)
  }

  useEffect(() => {
    getVersion()
  }, [])

  const { classes } = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className='text-dark order-2 order-md-1 d-flex flex-wrap align-items-center gap-2'>
          <span className='text-muted fw-bold'>{new Date().getFullYear()} &copy;</span>
          {APIData && (
            <span className='text-muted fs-7'>
              {APIData.softwareName} | {APIData.vendorName} | v{APIData.version} |{' '}
              {APIData.environment}
            </span>
          )}
        </div>

        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a href='https://lauduz.com/sobre-nos' className='menu-link ps-0 pe-2'>
              Sobre
            </a>
          </li>
          <li className='menu-item'>
            <a href='https://lauduz.com/contato' className='menu-link pe-0 pe-2'>
              Contato
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}
